"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadiusPicker = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/toggle-button/toggle-button-group");
const SQUARE_CLASS = 'shape-square';
const COLOR_CLASSES = ['color-black', 'color-green'];
const SHAPE_OPTIONS = [
    { value: 'circle', label: 'Circle' },
    { value: 'square', label: 'Square' },
];
const COLOR_OPTIONS = [
    { value: 'green', label: 'Green' },
    { value: 'black', label: 'Black' },
];
let RadiusPicker = class RadiusPicker extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.shape = 'circle';
        this.color = 'green';
    }
    render() {
        return (0, lit_1.html) `
      <mm-toggle-button-group
        stretch
        .options=${SHAPE_OPTIONS}
        .value=${this.shape}
        @change=${this.handleShapeChange}
      ></mm-toggle-button-group>

      <mm-toggle-button-group
        stretch
        .options=${COLOR_OPTIONS}
        .value=${this.color}
        @change=${this.handleColorChange}
      ></mm-toggle-button-group>
    `;
    }
    handleShapeChange(e) {
        this.shape = e.detail.value;
        document.documentElement.classList.toggle(SQUARE_CLASS, this.shape === 'square');
    }
    handleColorChange(e) {
        this.color = e.detail.value;
        COLOR_CLASSES.forEach(c => document.documentElement.classList.remove(c));
        document.documentElement.classList.add(`color-${this.color}`);
    }
};
RadiusPicker.styles = (0, lit_1.css) `
    :host {
      display: flex;
      flex-direction: column;
      gap: var(--space-2);
    }
  `;
__decorate([
    (0, decorators_js_1.state)()
], RadiusPicker.prototype, "shape", void 0);
__decorate([
    (0, decorators_js_1.state)()
], RadiusPicker.prototype, "color", void 0);
RadiusPicker = __decorate([
    (0, decorators_js_1.customElement)('mm-radius-picker')
], RadiusPicker);
exports.RadiusPicker = RadiusPicker;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmFkaXVzLXBpY2tlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInJhZGl1cy1waWNrZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQTJDO0FBQzNDLHFEQUF3RDtBQUN4RCxpRUFBOEQ7QUFFOUQsTUFBTSxZQUFZLEdBQUcsY0FBYyxDQUFBO0FBQ25DLE1BQU0sYUFBYSxHQUFHLENBQUMsYUFBYSxFQUFFLGFBQWEsQ0FBQyxDQUFBO0FBS3BELE1BQU0sYUFBYSxHQUFHO0lBQ3BCLEVBQUUsS0FBSyxFQUFFLFFBQVEsRUFBRSxLQUFLLEVBQUUsUUFBUSxFQUFFO0lBQ3BDLEVBQUUsS0FBSyxFQUFFLFFBQVEsRUFBRSxLQUFLLEVBQUUsUUFBUSxFQUFFO0NBQ3JDLENBQUE7QUFFRCxNQUFNLGFBQWEsR0FBRztJQUNwQixFQUFFLEtBQUssRUFBRSxPQUFPLEVBQUUsS0FBSyxFQUFFLE9BQU8sRUFBRTtJQUNsQyxFQUFFLEtBQUssRUFBRSxPQUFPLEVBQUUsS0FBSyxFQUFFLE9BQU8sRUFBRTtDQUNuQyxDQUFBO0FBR00sSUFBTSxZQUFZLEdBQWxCLE1BQU0sWUFBYSxTQUFRLGdCQUFVO0lBQXJDOztRQVFZLFVBQUssR0FBVSxRQUFRLENBQUE7UUFDdkIsVUFBSyxHQUFVLE9BQU8sQ0FBQTtJQThCekMsQ0FBQztJQTVCQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTs7O21CQUdJLGFBQWE7aUJBQ2YsSUFBSSxDQUFDLEtBQUs7a0JBQ1QsSUFBSSxDQUFDLGlCQUFpQjs7Ozs7bUJBS3JCLGFBQWE7aUJBQ2YsSUFBSSxDQUFDLEtBQUs7a0JBQ1QsSUFBSSxDQUFDLGlCQUFpQjs7S0FFbkMsQ0FBQTtJQUNILENBQUM7SUFFTyxpQkFBaUIsQ0FBQyxDQUFjO1FBQ3RDLElBQUksQ0FBQyxLQUFLLEdBQUcsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxLQUFjLENBQUE7UUFDcEMsUUFBUSxDQUFDLGVBQWUsQ0FBQyxTQUFTLENBQUMsTUFBTSxDQUFDLFlBQVksRUFBRSxJQUFJLENBQUMsS0FBSyxLQUFLLFFBQVEsQ0FBQyxDQUFBO0lBQ2xGLENBQUM7SUFFTyxpQkFBaUIsQ0FBQyxDQUFjO1FBQ3RDLElBQUksQ0FBQyxLQUFLLEdBQUcsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxLQUFjLENBQUE7UUFDcEMsYUFBYSxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDLFFBQVEsQ0FBQyxlQUFlLENBQUMsU0FBUyxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFBO1FBQ3hFLFFBQVEsQ0FBQyxlQUFlLENBQUMsU0FBUyxDQUFDLEdBQUcsQ0FBQyxTQUFTLElBQUksQ0FBQyxLQUFLLEVBQUUsQ0FBQyxDQUFBO0lBQy9ELENBQUM7O0FBckNNLG1CQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7OztHQU1sQixDQUFBO0FBQ1E7SUFBUixJQUFBLHFCQUFLLEdBQUU7MkNBQWdDO0FBQy9CO0lBQVIsSUFBQSxxQkFBSyxHQUFFOzJDQUErQjtBQVQ1QixZQUFZO0lBRHhCLElBQUEsNkJBQWEsRUFBQyxrQkFBa0IsQ0FBQztHQUNyQixZQUFZLENBdUN4QjtBQXZDWSxvQ0FBWSJ9